/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Fragment, useLayoutEffect, useRef, useState, useEffect, useContext } from 'react'
import { useParams, useLocation, useHistory } from 'react-router-dom';
import { Menu, Dialog, Transition } from '@headlessui/react'
import { get, ref, onValue, startAt, orderByKey, limitToFirst, query } from "firebase/database";
import axios from "axios";
import ReactJson from 'react18-json-view';
import 'react18-json-view/src/style.css'
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDownIcon, ChevronRightIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFileCsv, faCode, faRefresh, faEdit as IconEdit } from '@fortawesome/free-solid-svg-icons'
import { PlusIcon, TrashIcon } from '@heroicons/react/20/solid'
import { CalendarIcon, DocumentTextIcon, GlobeAltIcon, AdjustmentsHorizontalIcon, CodeBracketIcon, CodeBracketIcon as CustomCodeIcon } from '@heroicons/react/24/outline';
import { PencilIcon } from '@heroicons/react/20/solid'
import { Search } from 'lucide-react'

import { AuthContext } from "../../utils/auth.js";
import CreateExtraction from '../../components/CreateExtraction.js';
import ViewFile from '../../components/ViewFile.js';
import ModalForNewExtraction from '../../components/utils/ModalForNewExtraction.js';
import ModalForViewFile from '../../components/utils/ModalForViewFile.js';
import { handleGenerateJson, handleGenerateExcel, handleGenerateCsv, handleGenerateWord } from '../../components/functions/exportData.js';
import { db } from '../../utils/firebaseApp.js';
import Breadcrumb from '../../components/Breadcrumb';

import BatchHeading from './BatchFolder/BatchHeading.js';
import SelectFileStatus from './BatchFolder/SelectFileStatus.js';
import Pagination from './BatchFolder/Pagination.js';
import JsonViewerWindow from './BatchFolder/JsonViewer.js';
import { GoodNotificationCustom, ErrorNotificationCustom, GoodNotification, ErrorNotification } from './BatchFolder/Notifications.js';
import { ShowDeleteModalBatch, ShowDeleteModalFile, ShowDeleteModalFiles, ShowRedoModalFiles } from './BatchFolder/Modals.js';
import { DropdownWithDividerAndIcons, DropdownWithIcons } from './BatchFolder/Dropdowns.js';

import toast from 'react-hot-toast';

function classNames(...classes) { return classes.filter(Boolean).join(' ') }

export default function BatchScreen() {
  const { currentUser } = useContext(AuthContext);
  const location = useLocation();
  const history = useHistory();

  const adminEmails = ['barzoiu.alexandru@gmail.com', "alexraducu03@gmail.com"];
  const isAdmin = adminEmails.includes(currentUser.email);

  const [adminUserId, setAdminUserId] = useState('');
  const [searchedUserId, setSearchedUserId] = useState('');
  const [adminFileNameQuery, setAdminFileNameQuery] = useState('');

  // Load admin user ID from URL on mount
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const adminUserIdParam = queryParams.get('adminUserId');

    if (isAdmin && adminUserIdParam) {
      setSearchedUserId(adminUserIdParam);
      setAdminUserId(adminUserIdParam);
    }
  }, [isAdmin, location.search]);

  // Use searchedUserId if admin has searched, otherwise use current userId
  const targetUserId = (isAdmin && searchedUserId) ? searchedUserId : currentUser.uid;
  let userId = targetUserId;

  const serverUrl = process.env.REACT_APP_SERVER_URL;
  const environment = process.env.REACT_APP_ENV;

  const [isLoading, setIsLoading] = useState(true);

  const { batchId, extractionId } = useParams();
  const [files, setFiles] = useState([]);
  const [fields, setFields] = useState([]);
  const [extraction, setExtraction] = useState();
  const [batch, setBatch] = useState();

  const [itemsPerPage, setItemsPerPage] = useState(20);
  const maxCharactersForField = 75;
  const maxCharactersForFieldObject = 50;
  const [currentPage, setCurrentPage] = useState(1);
  const [noOfPages, setNoOfPages] = useState(0);
  const [noOfFiles, setNoOfFiles] = useState(0);

  const [showFileBool, setShowFileBool] = useState(false);
  const [selectedFile, setSelectedFile] = useState({
    file_id: '',
    file_url: '',
    file_name: '',
    status: '',
    data: {},
  });

  const [tabs, setTabs] = useState([
    { name: 'All', count: 0 },
    { name: 'To Review', count: 0 },
    { name: 'Confirmed', count: 0 },
    { name: 'Error', count: 0 },
  ]);

  const [currentTab, setCurrentTab] = useState('All');

  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [showDeleteFile, setShowDeleteFile] = useState(false);
  const [selectedFileIdDelete, setSelectedFileIdDelete] = useState(null);

  const [showDeleteFiles, setShowDeleteFiles] = useState(false);

  const [showRedoFiles, setShowRedoFiles] = useState(false);

  const [showErrorCustom, setShowErrorCustom] = useState(false);
  const [errorCustomTitle, setErrorCustomTitle] = useState('');
  const [errorCustomSubtitle, setErrorCustomSubtitle] = useState('');

  const [showSuccessCustom, setShowSuccessCustom] = useState(false);
  const [successCustomTitle, setSuccessCustomTitle] = useState('');
  const [successCustomSubtitle, setSuccessCustomSubtitle] = useState('');

  const [selectAllFromBatch, setSelectAllFromBatch] = useState(false);

  const checkbox = useRef()
  const [checked, setChecked] = useState(false)
  const [indeterminate, setIndeterminate] = useState(false)
  const [selectedFiles, setSelectedFiles] = useState([])
  const fileNameFilterActive = isAdmin && adminFileNameQuery.trim().length > 0;
  const selectsEntireBatch = checked && !fileNameFilterActive;

  useLayoutEffect(() => {
    const isIndeterminate = selectedFiles.length > 0 && selectedFiles.length < files.length
    setChecked(selectedFiles.length === files.length && files.length > 0)
    setIndeterminate(isIndeterminate)
    checkbox.current.indeterminate = isIndeterminate
  }, [selectedFiles, files])

  function toggleAll() {
    setSelectedFiles(checked || indeterminate ? [] : files)
    setChecked(!checked && !indeterminate)
    setIndeterminate(false)
  }

  function resetSelectedFiles() {
    setSelectedFiles([]);
    setChecked(false);
    setIndeterminate(false);
    checkbox.current.indeterminate = false;
  }

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
    resetSelectedFiles();
  }

  const previousPage = () => {
    setCurrentPage(currentPage - 1);
    resetSelectedFiles();
  }

  const selectPage = (pageNumber) => {
    if (currentPage === pageNumber) {
      return;
    } else {
      setCurrentPage(pageNumber);
      resetSelectedFiles();
    }
  }

  const fetchExtraction = async () => {
    // Use searchedUserId if admin has searched, otherwise use current userId
    const targetUserId = (isAdmin && searchedUserId) ? searchedUserId : currentUser.uid;
    let userId = targetUserId;

    // References for extraction and batch data
    const extractionRef = ref(db, `extractions/${userId}/${extractionId}`);
    const batchesRef = ref(db, `batches/${userId}/${extractionId}`); // Updated path for batches

    try {
      const [extractionSnapshot, batchesSnapshot] = await Promise.all([
        get(extractionRef),
        get(batchesRef)
      ]);

      if (extractionSnapshot.exists()) {
        const extractionData = extractionSnapshot.val();
        const batchesData = batchesSnapshot.exists() ? batchesSnapshot.val() : {};

        // Merge batches into the extractionData
        extractionData.batches = batchesData;

        setFields(extractionData.fields ?? []);
        setExtraction(extractionData);

        // Set the specific batch being viewed
        const currentBatch = batchesData[batchId] ?? null;
        setBatch(currentBatch);
        setNoOfFiles(currentBatch?.files?.length || 0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [unsubscribeFilesListener, setUnsubscribeFilesListener] = useState(null);

  const loadFiles = () => {
    setIsLoading(true);
    setFiles([]);

    // Define the path to query all files for a specific user's extraction and batch
    let queryPath = 'files/' + userId + '/' + extractionId + '/' + batchId;
    let itemsRef = ref(db, queryPath);

    // Query all files under the specified path
    const unsubscribe = onValue(itemsRef, (snapshot) => {
      const data = snapshot.val();
      let tempFiles = [];

      let countAll = 0;
      let countToReview = 0;
      let countConfirmed = 0;
      let countError = 0;

      if (data) {
        const fileNameQuery = isAdmin ? adminFileNameQuery.trim().toLowerCase() : '';

        // Loop over each file in the data
        Object.keys(data).forEach((key) => {
          let file = data[key];
          file.id = key;

          const visibleName = file.name ?? 'undefined';
          if (fileNameQuery && !visibleName.toString().toLowerCase().includes(fileNameQuery)) {
            return;
          }

          // Create a new file object
          let newFile = {
            id: file.id,
            name: visibleName,
            url: file.url,
            status: file.status,
            errorMessage: file.errorMessage,
            result: file.result ?? {},
            coordinates: file.coordinates ?? {},
            documentInfo: file.documentInfo ?? {},
          }

          // Filter files based on the current tab and status
          if (currentTab === 'All' && (file.status === 'processed' || file.status === 'waiting' || file.status === 'confirmed' || file.status === 'error')) {
            tempFiles.push(newFile);
          } else if (currentTab === 'To Review' && (file.status === 'processed' || file.status === 'waiting')) {
            tempFiles.push(newFile);
          } else if (currentTab === 'Confirmed' && file.status === 'confirmed') {
            tempFiles.push(newFile);
          } else if (currentTab === 'Error' && file.status === 'error') {
            tempFiles.push(newFile);
          }

          // Increment the counters based on the file status
          if (file.status === 'processed' || file.status === 'waiting' || file.status === 'confirmed' || file.status === 'error') countAll++;
          if (file.status === 'processed' || file.status === 'waiting') countToReview++;
          if (file.status === 'confirmed') countConfirmed++;
          if (file.status === 'error') countError++;
        });

        let totalItems = tempFiles.length;
        let tempNoOfPages = Math.ceil(totalItems / itemsPerPage);
        setNoOfPages(tempNoOfPages);

        // Ensure current page is valid and adjust if necessary
        if (currentPage > tempNoOfPages) {
          setCurrentPage(tempNoOfPages > 0 ? tempNoOfPages : 1);
        }

        // sort tempFiles: first is waiting, then processed, then confirmed, then error
        // tempFiles.sort((a, b) => {
        //   if (a.status === 'waiting' && b.status !== 'waiting') return -1;
        //   if (a.status === 'waiting' && b.status === 'waiting') return 0;
        //   if (a.status === 'processed' && b.status === 'confirmed') return -1;
        //   if (a.status === 'processed' && b.status === 'error') return -1;
        //   if (a.status === 'processed' && b.status === 'processed') return 0;
        //   if (a.status === 'confirmed' && b.status === 'error') return -1;
        //   if (a.status === 'confirmed' && b.status === 'confirmed') return 0;
        //   if (a.status === 'error' && b.status === 'error') return 0;
        //   return 1;
        // });

        let start = (currentPage - 1) * itemsPerPage;
        let end = start + itemsPerPage;
        // Slice the array to get the current page of items
        tempFiles = tempFiles.slice(start, end);

        // Update the state with the fetched files
        setFiles(tempFiles);

        // Update the tabs state with the new counts
        setTabs([
          { name: 'All', count: countAll },
          { name: 'To Review', count: countToReview },
          { name: 'Confirmed', count: countConfirmed },
          { name: 'Error', count: countError },
        ]);

        setIsLoading(false);
      }
    });

    // Set a function to unsubscribe from the database updates when needed
    setUnsubscribeFilesListener(() => unsubscribe);
  }

  const loadAllFiles = async () => {
    // Use searchedUserId if admin has searched, otherwise use current userId
    const targetUserId = (isAdmin && searchedUserId) ? searchedUserId : currentUser.uid;
    let userId = targetUserId;
    const databaseRef = ref(db, 'files/' + userId + '/' + extractionId + '/' + batchId);

    try {
      const snapshot = await get(databaseRef);

      if (snapshot.exists()) {
        const data = snapshot.val();
        return data;
      }
    } catch (error) {
      // console.error("Error fetching data:", error);
    }
  }

  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await fetchExtraction();
    }
    fetchData();
    resetSelectedFiles();
  }, [extractionId, batchId, searchedUserId, isAdmin]);

  useEffect(() => {
    if (extraction) {
      if (unsubscribeFilesListener) {
        unsubscribeFilesListener();
      }

      loadFiles();
    }

    return () => {
      if (unsubscribeFilesListener) {
        unsubscribeFilesListener();
      }
    };
  }, [currentPage, extraction, currentTab, itemsPerPage, refresh, adminFileNameQuery]);

  const showErrorFunction = () => {
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }

  const showSuccessFunction = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 2000);
  }

  const showErrorCustomFunction = ({ title, subtitle }) => {
    setErrorCustomTitle(title);
    setErrorCustomSubtitle(subtitle);
    setShowErrorCustom(true);

    setTimeout(() => {
      setShowErrorCustom(false);
    }, 2000);
  }

  const showSuccessCustomFunction = ({ title, subtitle }) => {
    setSuccessCustomTitle(title);
    setSuccessCustomSubtitle(subtitle);
    setShowSuccessCustom(true);

    setTimeout(() => {
      setShowSuccessCustom(false);
    }, 2000);
  }


  const selectAllFromBatchFunction = () => {
    if (selectAllFromBatch) {
      setSelectAllFromBatch(false);
    } else {
      setSelectAllFromBatch(true);
      resetSelectedFiles();
      toggleAll();
    }
  }

  const deleteBatch = async () => {
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/delete";

      await axios.post(url, {
        "extractionId": extractionId,
        "batchId": batchId,
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        }
      }).then(async (response) => {
        if (response.status === 200) {
          showSuccessCustomFunction({ title: 'Success', subtitle: 'Batch deleted successfully.' });
          await new Promise(r => setTimeout(r, 2000));
          window.location.href = "/extractions/" + extractionId;
        } else {
          showErrorCustomFunction({ title: 'Error', subtitle: 'An error occurred while trying to delete the batch.' });
        }
      }).catch((error) => {
        showErrorCustomFunction({ title: 'Error', subtitle: 'An error occurred while trying to delete the batch.' });
      });
    });
  }

  const reloadFiles = async () => {
    let fileIds = [];

    if (selectsEntireBatch) {
      const allFiles = await loadAllFiles();

      if (allFiles) {
        Object.keys(allFiles).forEach((key, index) => {
          fileIds.push(key);
        });
      } else {
        showErrorFunction();
        return;
      }
    } else {
      fileIds = selectedFiles.map(file => file.id);
    }

    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/redoFiles";

      await axios.post(url, {
        "extractionId": extractionId,
        "batchId": batchId,
        "fileIds": fileIds,
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        }
      }).then(async (response) => {
        if (response.status === 200) {
          await fetchExtraction();
          showSuccessCustomFunction({ title: 'Success', subtitle: 'Files will be processed shortly.' });
        } else {
          let errorTitle = 'Error';
          let errorSubtitle = 'An error occurred while trying to redo the files.';
          showErrorCustomFunction({ title: errorTitle, subtitle: errorSubtitle });
        }
      }).catch((error) => {
        let errorTitle = error.response.data.title ?? 'Error';
        let errorSubtitle = error.response.data.subtitle ?? 'An error occurred while trying to redo the files.';
        showErrorCustomFunction({ title: errorTitle, subtitle: errorSubtitle });
      });
    });
  }

  const reloadFile = async ({ fileId }) => {
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/redoFile";

      await axios.post(url, {
        "extractionId": extractionId,
        "batchId": batchId,
        "fileId": fileId,
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        }
      }).then(async (response) => {
        if (response.status === 200) {
          await fetchExtraction();
          showSuccessCustomFunction({ title: 'Success', subtitle: 'File will be processed shortly.' });
        } else {
          let errorTitle = 'Error';
          let errorSubtitle = 'An error occurred while trying to redo the file.';
          showErrorCustomFunction({ title: errorTitle, subtitle: errorSubtitle });
        }
      }).catch((error) => {
        let errorTitle = error.response.data.title ?? 'Error';
        let errorSubtitle = error.response.data.subtitle ?? 'An error occurred while trying to redo the file.';
        showErrorCustomFunction({ title: errorTitle, subtitle: errorSubtitle });
      });
    });
  }

  const deleteFile = async ({ fileId }) => {
    await currentUser.getIdToken().then(async (idToken) => {
      const url = serverUrl + "/delete";

      await axios.post(url, {
        "extractionId": extractionId,
        "batchId": batchId,
        "fileId": fileId,
      }, {
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${idToken}`
        }
      }).then(async (response) => {
        if (response.status === 200) {
          await fetchExtraction();
        } else {
        }
      }).catch((error) => {
      });
    });
  }

  const deleteFiles = async () => {
    if (selectsEntireBatch) {
      deleteBatch();
    } else {
      selectedFiles.forEach((file, index) => {
        deleteFile({ fileId: file.id });
      });

      setRefresh(!refresh);
    }
    resetSelectedFiles();
  }

  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isOneFile, setIsOneFile] = useState(false);

  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
    return new Date(Number(dateString)).toLocaleDateString(undefined, options);
  }

  const openFileResult = async (file) => {
    setSelectedFile({
      file_id: file.id,
      file_url: file.url,
      file_name: file.name,
      status: file.status,
      data: file.result,
      coordinates: file.coordinates,
      documentInfo: file.documentInfo,
    })

    setShowFileBool(true);
  }

  const pages = [
    {
      name: extraction == null ? extractionId : extraction.name,
      href: searchedUserId
        ? `/extractions/${extractionId}?adminUserId=${searchedUserId}`
        : `/extractions/${extractionId}`,
      current: false
    },
    {
      name: 'Batch ' + batchId,
      href: searchedUserId
        ? `/extractions/${extractionId}/batch/${batchId}?adminUserId=${searchedUserId}`
        : `/extractions/${extractionId}/batch/${batchId}`,
      current: true
    },
  ]

  const [isChangingTab, setIsChangingTab] = useState(false);

  const changeTab = (tab) => {
    if (tab === currentTab) return;

    setCurrentTab(tab);
    setCurrentPage(1);

    // unselect all files
    resetSelectedFiles();

    setIsChangingTab(true);
    setTimeout(() => {
      setIsChangingTab(false);
    }, 250);
  }

  const handleAdminSearch = () => {
    if (adminUserId.trim()) {
      setSearchedUserId(adminUserId.trim());
      // Add adminUserId to URL
      const queryParams = new URLSearchParams(location.search);
      queryParams.set('adminUserId', adminUserId.trim());
      history.replace(`${location.pathname}?${queryParams.toString()}`);
    }
  };

  const handleAdminSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleAdminSearch();
    }
  };

  const handleClearSearch = () => {
    setAdminUserId('');
    setSearchedUserId('');
    setAdminFileNameQuery('');
    setCurrentPage(1);
    if (checkbox.current) {
      resetSelectedFiles();
    }
    // Remove adminUserId from URL
    const queryParams = new URLSearchParams(location.search);
    queryParams.delete('adminUserId');
    const newUrl = queryParams.toString()
      ? `${location.pathname}?${queryParams.toString()}`
      : location.pathname;
    history.replace(newUrl);
  };

  const handleAdminFileNameChange = (value) => {
    setAdminFileNameQuery(value);
    setCurrentPage(1);
    if (checkbox.current) {
      resetSelectedFiles();
    }
  };

  return (
    <div className="">
      <Breadcrumb
        pages={pages}
        currentHref={searchedUserId ? `/extractions?adminUserId=${searchedUserId}` : "/extractions"}
      />

      <ErrorNotification showError={showError} setShowError={setShowError} />
      <GoodNotification showError={showSuccess} setShowError={setShowSuccess} />

      <ErrorNotificationCustom showError={showErrorCustom} setShowError={setShowErrorCustom} errorTitle={errorCustomTitle} errorSubtitle={errorCustomSubtitle} />
      <GoodNotificationCustom showError={showSuccessCustom} setShowError={setShowSuccessCustom} successfulTitle={successCustomTitle} successfulSubtitle={successCustomSubtitle} />

      <ShowDeleteModalBatch open={showDelete} setOpen={setShowDelete} deleteFunction={() => {
        deleteBatch();
        setShowDelete(false);
      }} />

      <ShowDeleteModalFile open={showDeleteFile} setOpen={setShowDeleteFile} deleteFunction={() => {
        deleteFile({ fileId: selectedFileIdDelete });
        setShowDeleteFile(false);
      }} />

      <ShowDeleteModalFiles open={showDeleteFiles} setOpen={setShowDeleteFiles} noOfFiles={selectsEntireBatch ? noOfFiles : selectedFiles.length} isBatch={selectsEntireBatch} deleteFunction={() => {
        deleteFiles();
        setShowDeleteFiles(false);
      }} />

      <ShowRedoModalFiles open={showRedoFiles} setOpen={setShowRedoFiles} noOfFiles={selectsEntireBatch ? noOfFiles : selectedFiles.length} isBatch={selectsEntireBatch} redoFunction={async () => {
        await reloadFiles();
        setShowRedoFiles(false);
        resetSelectedFiles();
      }} />

      <ModalForNewExtraction
        open={open}
        setOpen={setOpen}
        close={() => { }}
      >
        <CreateExtraction
          closeModal={() => {
            setOpen(false);
            changeTab('All');
          }}
        />
      </ModalForNewExtraction>

      <ModalForNewExtraction
        open={open2}
        setOpen={setOpen2}
        close={() => { }}
      >
        {/* edit extraction */}
        <CreateExtraction isEdit={true} closeModal={() => {
          setOpen2(false);
          fetchExtraction();
        }} />
      </ModalForNewExtraction>

      <ModalForViewFile open={showFileBool} setOpen={setShowFileBool} >
        <ViewFile
          closeModal={() => {
            setShowFileBool(false);
            setSelectedFile({
              file_id: '',
              file_url: '',
              file_name: '',
              status: '',
              data: {},
            });
          }}
          extractionId={extractionId}
          batchId={batchId}
          fileData={selectedFile}
          extraction={extraction}
          initialFileStatus={currentTab}
        />
      </ModalForViewFile>

      {showExportModal &&
        <ExportDialog
          open={showExportModal}
          setOpen={setShowExportModal}
          files={files}
          isOneFile={isOneFile}
          index={selectedIndex}
          checked={selectsEntireBatch}
          selectedFiles={selectedFiles}
          loadAllFiles={loadAllFiles}
          extraction={extraction}
          userId={userId}
          extractionId={extractionId}
        />
      }

      <div className="">
        <BatchHeading
          batchName={(extraction?.batches[batchId]?.name ? "Batch " + extraction?.batches[batchId]?.name : "Batch")}
          batchCreatedAt={formatDate(extraction?.batches[batchId].startTime)}
          batchUpdatedAt={formatDate(extraction?.batches[batchId].startTime)}
          batchFilesCount={extraction?.batches[batchId]?.files?.length || 0}
          batchFieldsCount={extraction?.fields.length}
          batchOrigin={extraction?.batches[batchId].origin}
          deleteBatch={() => setShowDelete(true)}
          editExtraction={() => setOpen2(true)}
          extractionId={extractionId}
          batchId={batchId}
        />
      </div>

      {/* Admin Search */}
      {isAdmin && (
        <div className="mt-6 bg-indigo-50 border border-indigo-200 rounded-lg p-4">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center rounded-md bg-indigo-100 px-2 py-1 text-xs font-medium text-indigo-700">
              Admin
            </span>
            <h3 className="text-sm font-semibold text-indigo-900">View files for any user</h3>
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <input
              type="text"
              value={adminUserId}
              onChange={(e) => setAdminUserId(e.target.value)}
              onKeyPress={handleAdminSearchKeyPress}
              placeholder="Enter User ID"
              className="flex-1 min-w-[200px] text-sm border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            <button
              onClick={handleAdminSearch}
              disabled={!adminUserId.trim()}
              className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Search className="h-4 w-4" />
              Search
            </button>
            {searchedUserId && (
              <button
                onClick={handleClearSearch}
                className="inline-flex items-center gap-x-1.5 rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500"
              >
                Clear
              </button>
            )}
          </div>
          {searchedUserId && (
            <p className="mt-2 text-sm text-indigo-700">
              Viewing files for user: <span className="font-mono font-semibold">{searchedUserId}</span>
            </p>
          )}
          <div className="mt-4 flex flex-wrap items-center gap-2">
            <label htmlFor="admin-file-name-search" className="text-sm font-medium text-indigo-900 whitespace-nowrap">
              Filter by file name
            </label>
            <input
              id="admin-file-name-search"
              type="text"
              value={adminFileNameQuery}
              onChange={(e) => handleAdminFileNameChange(e.target.value)}
              placeholder="Enter file name"
              className="flex-1 min-w-[200px] text-sm border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
            {adminFileNameQuery.trim() && (
              <button
                onClick={() => handleAdminFileNameChange('')}
                className="inline-flex items-center gap-x-1.5 rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500"
              >
                Clear
              </button>
            )}
          </div>
        </div>
      )}

      <div className="sm:flex sm:items-center mt-7">
        <div className="sm:flex-auto">
          <h3 className="text-base font-semibold leading-6 text-gray-900">Files</h3>
          <p className="mt-1 text-sm text-gray-500">
            A list of all files uploaded to this batch.
          </p>
        </div>

        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            onClick={() => setOpen(true)}
            className="ml-2 inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            <PlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
            Add files
          </button>
        </div>
      </div>

      <div className="mt-5">
        <SelectFileStatus
          tabs={tabs}
          currentTab={currentTab}
          changeTab={changeTab}
        />
      </div>

      <div className="mt-2 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto overflow-y-hidden sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <div className="relative">
              {selectedFiles.length > 0 && (
                <div className="absolute left-14 top-0 flex h-12 items-center space-x-3 bg-white sm:left-12">
                  {!selectsEntireBatch && (
                    <button
                      type="button"
                      className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      {selectedFiles.length} {selectedFiles.length > 1 ? 'files' : 'file'} selected
                    </button>
                  )}
                  {selectsEntireBatch && (
                    <button
                      type="button"
                      className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      {noOfFiles} {noOfFiles > 1 ? 'files' : 'file'} selected
                    </button>
                  )}
                  {selectAllFromBatch &&
                    <button
                      onClick={() => selectAllFromBatchFunction()}
                      type="button"
                      className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      All batch selected
                    </button>}
                  {!selectsEntireBatch && (
                    <button
                      type="button"
                      onClick={() => setShowRedoFiles(true)}
                      className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      Redo {selectedFiles.length > 1 ? 'files' : 'file'}
                    </button>)}
                  {selectsEntireBatch && (
                    <button
                      type="button"
                      onClick={() => setShowRedoFiles(true)}
                      className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                    >
                      Redo {noOfFiles > 1 ? 'files' : 'file'}
                    </button>)}
                  <button
                    type="button"
                    onClick={() => setShowDeleteFiles(true)}
                    className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
                  >
                    Delete
                  </button>
                  <Menu as="div" className="relative inline-block text-left overflow-visible">
                    <div className='z-50' onClick={() => {
                      setIsOneFile(false);
                      setSelectedIndex(0);
                      setShowExportModal(true);
                    }}>
                      <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                        Export As
                        <ChevronRightIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                      </Menu.Button>
                    </div>
                  </Menu>
                </div>
              )}

              <table className={classNames("min-w-full table-fixed divide-y divide-gray-300",
                files.length <= 0 ? 'hidden' : ''
              )}>
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className={classNames("relative px-7 sm:w-12 sm:px-6", (isChangingTab || files.length <= 0) ? 'hidden' : '')}
                    >
                      <input
                        type="checkbox"
                        className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                        ref={checkbox}
                        checked={checked}
                        onChange={toggleAll}
                      />
                    </th>
                    <th scope="col" className="py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">
                      {isChangingTab && <Skeleton width={80} height={20} className="" />}
                      {!isChangingTab && "File name".toUpperCase()}
                    </th>
                    {environment === "development" && (
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        {isChangingTab && <Skeleton width={80} height={20} className="" />}
                        {!isChangingTab && "Redo".toUpperCase()}
                      </th>
                    )}
                    <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                      {isChangingTab && <Skeleton width={80} height={20} className="" />}
                      {!isChangingTab && "Status".toUpperCase()}
                    </th>
                    {fields.map((field) => (
                      <th key={field.key} scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        {isChangingTab && <Skeleton width={80} height={20} className="" />}
                        {!isChangingTab && field.key.toUpperCase()}
                      </th>
                    ))}
                    {selectedFiles.length <= 0 &&
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-3">
                        <span className="sr-only">Edit</span>
                      </th>
                    }
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {isChangingTab && (
                    <tr>
                      <td colSpan={fields.length + 3} className="py-8">
                        <Skeleton className='mb-3' height={20} count={itemsPerPage} />
                      </td>
                    </tr>
                  )}

                  {!isChangingTab && files.map((file, index) => (
                    <tr key={file.id} className={selectedFiles.includes(file) ? 'bg-gray-50' : undefined}>
                      <td className="relative px-7 sm:w-12 sm:px-6">
                        {selectedFiles.includes(file) && (
                          <div className="absolute inset-y-0 left-0 w-0.5 bg-indigo-600" />
                        )}
                        <input
                          type="checkbox"
                          className="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                          value={file.id}
                          checked={selectedFiles.includes(file)}
                          onChange={(e) =>
                            setSelectedFiles(
                              e.target.checked
                                ? [...selectedFiles, file]
                                : selectedFiles.filter((p) => p !== file)
                            )
                          }
                        />
                      </td>
                      <td
                        className={classNames(
                          'whitespace-nowrap py-4 pr-3 text-sm font-medium',
                          selectedFiles.includes(file) ? 'text-indigo-600' : 'text-gray-900'
                        )}
                      >
                        <div className='flex items-center group'>
                          <button onClick={() => openFileResult(file)}>
                            <span className='group-hover:underline group-hover:text-indigo-600 mr-1.5 cursor-pointer'>
                              {file.name}
                            </span>
                          </button>
                          <button
                            onClick={() => openFileResult(file)}
                            className="inline-flex items-center justify-center h-6 w-6 rounded-full text-gray-400 group-hover:text-gray-500 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-indigo-500"
                          >
                            <FontAwesomeIcon icon={IconEdit} />
                          </button>
                        </div>
                      </td>
                      {environment === "development" && (
                        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" >
                          <button
                            onClick={() => reloadFile({ fileId: file.id })}
                            className="px-3 py-1 bg-white border border-gray-300 rounded text-gray-600 text-sm hover:bg-gray-50"
                          >
                            Redo
                          </button>
                        </td>
                      )}
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" >
                        <span className='text-red-300'>
                          {file.status === 'error' ? 'error' : ''}
                          {file.status === 'error' ? (
                            file.errorMessage !== undefined ? (': ' + file.errorMessage) : ''
                          ) : ''}
                        </span>
                        <span className='text-orange-300'>
                          {file.status === 'waiting' ? 'processing' : ''}
                        </span>
                        <span className=''>
                          {file.status === 'processed' ? 'processed' : ''}
                        </span>
                        <span className=''>
                          {file.status === 'confirmed' ? 'confirmed' : ''}
                        </span>
                      </td>
                      {fields.map((field, index) => {
                        if (isChangingTab) {
                          return (
                            <td key={"fields_" + index} className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                              <Skeleton width={80} height={20} className="" />
                            </td>
                          );
                        }

                        const value = file.result[field.key];
                        let displayValue;
                        let titleValue = ''; // Used for hover tooltip
                        let type = '';

                        if (typeof value === 'string') {
                          displayValue = value.length > maxCharactersForField ? value.slice(0, maxCharactersForField) + '...' : value;
                          titleValue = value.length > maxCharactersForField ? value : '';
                          type = 'string';
                        } else if (value) {
                          // Convert object or list to string
                          const stringValue = JSON.stringify(value);
                          displayValue = stringValue.length > maxCharactersForFieldObject ? stringValue.slice(0, maxCharactersForFieldObject) + '...' : stringValue;
                          titleValue = stringValue.length > maxCharactersForFieldObject ? stringValue : '';
                          type = 'object';
                        } else {
                          displayValue = '-';
                        }

                        if (type === 'object') {
                          return (
                            <td key={"fields_" + index} className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                              <div className='flex flex-row items-center'>
                                <div className="truncate" title={titleValue}>
                                  {displayValue}
                                </div>
                                <JsonViewerWindow key={"fields_json_" + index} jsonData={value} />
                              </div>
                            </td>
                          );
                        } else {
                          return (
                            <td key={"fields_" + index} className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                              <div className="truncate" title={titleValue}>
                                {displayValue}
                              </div>
                            </td>
                          );
                        }
                      })}
                      {selectedFiles.length <= 0 &&
                        <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3 relative">
                          <DropdownWithDividerAndIcons
                            className="overflow-visible"
                            file={file}
                            exportAs={() => {
                              setIsOneFile(true);
                              setSelectedIndex(index);
                              setShowExportModal(true);
                            }}
                            reloadFile={reloadFile}
                            deleteFile={({ fileId }) => {
                              setShowDeleteFile(true);
                              setSelectedFileIdDelete(fileId);
                            }}
                            initialButton={
                              <Menu.Button className="flex items-center">
                                <span className="text-indigo-600 hover:text-indigo-900">
                                  Options<span className="sr-only">, {file.name}</span>
                                </span>
                              </Menu.Button>
                            }
                          />
                        </td>
                      }
                    </tr>
                  ))}
                </tbody>
              </table>

              {/* Show a message if there are no files */}
              {!isChangingTab && files.length <= 0 && currentTab === 'All' && adminFileNameQuery.trim() &&
                <div className="mt-4 flex-1 flex flex-col items-center justify-center h-full rounded-lg bg-gray-100 p-12">
                  <div className="text-center">
                    <h2 className="text-xl font-semibold text-gray-900">No files found</h2>
                    <p className="mt-1.5 text-sm text-gray-600">
                      Try a different file name or clear the filter.
                    </p>
                  </div>
                </div>
              }
              {!isChangingTab && files.length <= 0 && currentTab === 'All' && !adminFileNameQuery.trim() &&
                <div className="mt-4 flex-1 flex flex-col items-center justify-center h-full rounded-lg bg-gray-100 p-12">
                  <div className="text-center">
                    <h2 className="text-xl font-semibold text-gray-900">No files yet</h2>
                    <p className="mt-1.5 text-sm text-gray-600">
                      Upload files to this batch.
                    </p>
                    <button
                      onClick={() => setOpen(true)}
                      className="mt-3 ml-2 inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <PlusIcon className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                      Add files
                    </button>
                  </div>
                </div>
              }
              {files.length <= 0 && !isChangingTab && currentTab !== 'All' && (
                <div className="mt-4 flex-1 flex flex-col items-center justify-center h-full rounded-lg bg-gray-100 p-16">
                  <div className="text-center">
                    <h2 className="text-xl font-semibold text-gray-900">
                      {adminFileNameQuery.trim() ? 'No files found' : 'There are no files with this status'}
                    </h2>
                    {adminFileNameQuery.trim() && (
                      <p className="mt-1.5 text-sm text-gray-600">
                        Try a different file name or clear the filter.
                      </p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {
        files.length > 0 && (
          <Pagination
            numberOfPages={noOfPages}
            currentPageNumber={currentPage}
            previousButton={previousPage}
            nextButton={nextPage}
            selectPage={selectPage}
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
          />)
      }
    </div >
  )
}

function ExportDialog({ open, setOpen, files, isOneFile, index, checked, selectedFiles, loadAllFiles, extraction, userId, extractionId }) {
  const cancelButtonRef = useRef(null);

  const objectFields = extraction.fields.filter(field => field.type === 'object');
  const arrayFields = extraction.fields.filter(field =>
    field.type === 'array' &&
    field.items &&
    (field.items.type === 'object' || field.items.type === 'string')
  );

  const [fileFormat, setFileFormat] = useState('excel');
  const [selectedArrayField, setSelectedArrayField] = useState('');
  const [selectedObjectFields, setSelectedObjectFields] = useState([]);

  const handleFileExport = async () => {
    try {
      let currentDateTime = new Date().toISOString();
      let formattedDateTime = currentDateTime.slice(0, 10);
      let fileName = 'Extracta LABS - Data Export - ' + formattedDateTime;

      let outputArray = [];

      if (isOneFile) {
        const file = files[index];
        outputArray = [{
          file_name: file.name,
          data: file.result,
        }];
      } else {
        if (checked) {
          // get all the files from the batch
          const allFiles = await loadAllFiles();

          if (allFiles) {
            Object.keys(allFiles).forEach((key, index) => {
              let file = allFiles[key];
              outputArray.push({
                file_name: file.name,
                data: file.result,
              });
            });
          } else {
            toast.error('Error exporting file!');
            return;
          }
        } else {
          // get only the selected files
          selectedFiles.forEach((file, index) => {
            outputArray.push({
              file_name: file.name,
              data: file.result,
            });
          });
        }
      }

      // Copy results so export never mutates the files shown in the table.
      // A missing or invalid result (for example a failed file) becomes {}.
      outputArray = outputArray.map(item => ({
        file_name: item.file_name,
        data: (item.data && typeof item.data === 'object' && !Array.isArray(item.data))
          ? { ...item.data }
          : {},
      }));

      // if the file has more fields than the extraction's fields, remove the extra fields
      outputArray.forEach(item => {
        Object.keys(item.data).forEach(key => {
          if (!extraction.fields.some(field => field.key === key)) {
            delete item.data[key];
          }
        });
      });

      // if the file has less fields than the extraction's fields, add the missing fields with a value of '-'
      extraction.fields.forEach(field => {
        outputArray.forEach(item => {
          if (!Object.prototype.hasOwnProperty.call(item.data, field.key)) {
            item.data[field.key] = '-';
          }
        });
      });

      let extractionFields = extraction.fields;

      // Handle array expansion first if needed
      if ((fileFormat === 'excel' || fileFormat === 'csv') && selectedArrayField) {
        const { expandedOutput, newFields } = expandArrayField(outputArray, selectedArrayField, extractionFields);
        extractionFields = newFields;
        outputArray = expandedOutput;
      }

      // Then handle object field splitting
      if ((fileFormat === 'excel' || fileFormat === 'csv') && selectedObjectFields.length > 0) {
        const { expandedOutput, newFields } = expandObjectFields(outputArray, selectedObjectFields, extractionFields);
        extractionFields = newFields;
        outputArray = expandedOutput;
      }

      switch (fileFormat) {
        case 'json':
          handleGenerateJson(outputArray, fileName, extractionFields);
          break;
        case 'excel':
          handleGenerateExcel(outputArray, fileName, extractionFields);
          break;
        case 'csv':
          handleGenerateCsv(outputArray, fileName, extractionFields);
          break;
        case 'word':
          handleGenerateWord(outputArray, fileName);
          break;
        default:
          break;
      }

      toast.success('File exported successfully!');
      setOpen(false);
    } catch (error) {
      console.error('Export error:', error);
      toast.error('Error exporting file!');
      setOpen(false);
    }
  }

  const expandObjectFields = (outputArray, objectFieldKeys, fields) => {
    let expandedOutput = outputArray;
    let newFields = [];

    // Process fields in order, replacing object fields with their properties
    fields.forEach(field => {
      if (objectFieldKeys.includes(field.key)) {
        // If this is a selected object field, expand its properties
        const properties = field.properties || [];
        const newFieldEntries = properties.map(property => ({
          description: property.description,
          key: `${field.key}.${property.key}`,
          type: property.type,
        }));
        newFields.push(...newFieldEntries);

        // Update the data in the output array for this field
        expandedOutput = expandedOutput.map(item => {
          const newItem = {
            ...item,
            data: (item.data && typeof item.data === 'object' && !Array.isArray(item.data))
              ? { ...item.data }
              : {},
          };
          const rawObject = newItem.data[field.key];
          const objectData = (rawObject && typeof rawObject === 'object' && !Array.isArray(rawObject))
            ? rawObject
            : {};

          // Add flattened object properties
          properties.forEach(property => {
            const propertyKey = `${field.key}.${property.key}`;
            newItem.data[propertyKey] = objectData[property.key] || '';
          });

          // Remove the original object
          delete newItem.data[field.key];

          return newItem;
        });
      } else {
        // If not a selected object field, keep it as is
        newFields.push(field);
      }
    });

    return { expandedOutput, newFields };
  };

  const expandArrayField = (outputArray, arrayFieldKey, fields) => {
    let expandedOutput = [];

    // Find the index of the original array field in the fields array
    const originalFieldIndex = fields.findIndex(field => field.key === arrayFieldKey);

    // Filter out the original array field from the new fields array (but only for object arrays)
    let newFields = fields.filter(field => field.key !== arrayFieldKey);

    // Find the arrayField structure in extraction.fields to get the properties
    const arrayFieldStructure = fields.find(field => field.key === arrayFieldKey);
    let properties = [];

    if (arrayFieldStructure && arrayFieldStructure.items && arrayFieldStructure.items.properties) {
      // Sort the properties based on the 'id' field to maintain the correct order
      properties = arrayFieldStructure.items.properties.sort((a, b) => a.id - b.id);
    }

    // Loop through each item in the outputArray
    outputArray.forEach(item => {
      let data = (item.data && typeof item.data === 'object' && !Array.isArray(item.data))
        ? item.data
        : {};

      // Find the field that corresponds to the chosen array field
      let arrayField = data[arrayFieldKey];

      // If the field is not an array or does not exist, skip
      if (!Array.isArray(arrayField)) {
        expandedOutput.push({ ...item, data }); // Just push the original data if it's not an array
        return;
      }

      // Check if the array contains objects or strings
      if (typeof arrayField[0] === 'object' && !Array.isArray(arrayField[0])) {
        // Case where array items are objects (expand each object's properties into separate columns)
        arrayField.forEach(arrayEntry => {
          let newRow = { ...data }; // Clone the original data

          // Remove the arrayFieldKey from the newRow (we're expanding its fields)
          delete newRow[arrayFieldKey];

          const entry = (arrayEntry && typeof arrayEntry === 'object' && !Array.isArray(arrayEntry))
            ? arrayEntry
            : {};

          // Spread object keys (from arrayEntry) into multiple columns in the new row using child keys only, keeping the order based on `properties`
          properties.forEach(property => {
            const key = property.key;
            newRow[`${arrayFieldKey}.${key}`] = entry[key];
          });

          // Add the expanded row to the output
          expandedOutput.push({
            ...item, // Keep the rest of the item info (e.g., file name)
            data: newRow // Update data with the expanded row
          });
        });

        // Insert the new fields at the index of the original array field
        const newFieldEntries = properties.map(property => ({
          description: property.description,
          key: `${arrayFieldKey}.${property.key}`,
          type: property.type,
        }));

        // Insert the new field entries at the original index
        newFields.splice(originalFieldIndex, 0, ...newFieldEntries);
      } else if (typeof arrayField[0] === 'string') {
        // Case where array items are strings (create a new row for each string)
        arrayField.forEach(stringValue => {
          let newRow = { ...data }; // Clone the original data
          delete newRow[arrayFieldKey]; // Remove the original array field
          newRow[arrayFieldKey] = stringValue; // Keep the original field name for string values

          // Add the new row to the expanded output
          expandedOutput.push({
            ...item, // Keep the rest of the item info
            data: newRow // Update data with the single string value
          });
        });

        // For string arrays, keep the original field name and type
        const originalField = fields.find(field => field.key === arrayFieldKey);
        if (originalField) {
          const newField = {
            ...originalField,
            key: arrayFieldKey, // Keep the original key without .value
          };
          newFields.splice(originalFieldIndex, 0, newField);
        }
      }
    });

    return { expandedOutput, newFields }; // Return both the expanded output and the updated fields
  };

  const showWord = () => {
    const userIds = ['WgVLxXREk7eW2aQeFOSfRbuxJbm1', 'wZfRgTE69LO3BMn1gYtH4ovWeif2', 'uCiWcuKd3ebpbcblafD17Nb1ESV2', 'WOc41gZqwzQdewbi5uTdm3W0xlw1'];
    const extractionIds = ['-O8jj-L82xWGj4C8D7Mu', '-O86GTicjQx2F27obn0Y', '-O86NndgLlK1TKcIU1d_', '-O8jmir7skz8jJykD2H6'];
    return userIds.includes(userId) && extractionIds.includes(extractionId);
  }

  const handleObjectFieldChange = (fieldKey) => {
    setSelectedObjectFields(prev => {
      if (prev.includes(fieldKey)) {
        return prev.filter(key => key !== fieldKey);
      } else {
        return [...prev, fieldKey];
      }
    });
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-100" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-100 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6">
                  <h2 className="text-xl font-semibold mb-6">Export Options</h2>

                  <div className="space-y-6">
                    {/* File Format Section */}
                    <div className="space-y-2">
                      <h3 className="text-sm font-medium text-gray-900">File Format</h3>
                      <div className="flex space-x-2">
                        <button
                          className={`flex-1 px-4 py-2 border rounded-md ${fileFormat === 'excel' ? 'bg-indigo-600 text-white border-indigo-600' : 'border-gray-300'}`}
                          onClick={() => setFileFormat('excel')}
                        >
                          Excel
                        </button>
                        <button
                          className={`flex-1 px-4 py-2 border rounded-md ${fileFormat === 'csv' ? 'bg-indigo-600 text-white' : 'border-gray-300'}`}
                          onClick={() => setFileFormat('csv')}
                        >
                          CSV
                        </button>
                        <button
                          className={`flex-1 px-4 py-2 border rounded-md ${fileFormat === 'json' ? 'bg-indigo-600 text-white' : 'border-gray-300'}`}
                          onClick={() => setFileFormat('json')}
                        >
                          JSON
                        </button>
                        {showWord() && (
                          <button
                            className={`flex-1 px-4 py-2 border rounded-md ${fileFormat === 'word' ? 'bg-indigo-600 text-white' : 'border-gray-300'}`}
                            onClick={() => setFileFormat('word')}
                          >
                            Word
                          </button>
                        )}
                      </div>
                    </div>

                    {/* Array Expansion Section - Only for Excel and CSV */}
                    {(fileFormat === 'excel' || fileFormat === 'csv') && arrayFields.length > 0 && (
                      <div className="space-y-2 pt-4 border-t">
                        <h3 className="text-sm font-medium text-gray-900">Expand Arrays to Multiple Rows</h3>
                        <p className="text-sm text-gray-500">
                          Select an array field to expand its items across multiple rows. Works with both arrays of objects and arrays of strings.
                        </p>
                        <select
                          value={selectedArrayField}
                          onChange={(e) => setSelectedArrayField(e.target.value)}
                          className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        >
                          <option value="">Don't expand arrays</option>
                          {arrayFields.map((field) => (
                            <option key={field.key} value={field.key}>
                              {field.key}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* Object Splitting Section - Only for Excel and CSV */}
                    {(fileFormat === 'excel' || fileFormat === 'csv') && objectFields.length > 0 && (
                      <div className="space-y-2 pt-4 border-t">
                        <h3 className="text-sm font-medium text-gray-900">Split Objects into Columns</h3>
                        <p className="text-sm text-gray-500">
                          Select object fields to split their properties into separate columns.
                        </p>
                        <div className="space-y-2 mt-2">
                          {objectFields.map((field) => (
                            <div key={field.key} className="flex items-center">
                              <input
                                type="checkbox"
                                id={`object-field-${field.key}`}
                                checked={selectedObjectFields.includes(field.key)}
                                onChange={() => handleObjectFieldChange(field.key)}
                                className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                              />
                              <label
                                htmlFor={`object-field-${field.key}`}
                                className="ml-2 block text-sm text-gray-900"
                              >
                                {field.key}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto"
                    onClick={handleFileExport}
                  >
                    Export File
                  </button>
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    ref={cancelButtonRef}
                    onClick={() => setOpen(false)}
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}